export class GridViewSwitcher extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.saveState(this.currentDesktopState, this.desktopStorageKey)
    this.saveState(this.currentMobileState, this.mobileStorageKey)
  }

  setupListeners () {
    super.setupListeners()
    this.listeners.add(this, 'click', this.onClickHandler)
  }

  onClickHandler () {
    if (window.innerWidth >= 768) {
      const newDesktopState = this.nextDestkopState

      this.dataset.gridViewSwitcherStateDesktop = newDesktopState
      this.externalEls.grid.element.dataset.gridViewStateDesktop = newDesktopState

      this.saveState(newDesktopState, this.desktopStorageKey)
    } else {
      const newMobileState = this.nextMobileState

      this.dataset.gridViewSwitcherState = newMobileState
      this.externalEls.grid.element.dataset.gridViewState = newMobileState

      this.saveState(newMobileState, this.mobileStorageKey)
    }

    this.updateImageSizes()
  }

  saveState (nameOfState, storageKey) {
    if (this.saveStateTimer) {
      clearTimeout(this.saveStateTimer)
    }

    this.saveStateTimer = setTimeout(() => {
      window.BAO.Cart.updateCartAttributes({
        [storageKey]: nameOfState,
      })

      window.sessionStorage.setItem(storageKey, nameOfState)
    }, 600)
  }

  updateImageSizes () {
    const images = this.externalEls?.grid?.element?.querySelectorAll('img')

    if (!images) {
      return
    }

    const imageSizes = this.imageSizes

    images.forEach(image => {
      image.sizes = imageSizes
    })
  }

  get mobileStates () {
    return ['big', 'small', 'smallest']
  }

  get currentMobileState () {
    return this.dataset.gridViewSwitcherState
  }

  get nextMobileState () {
    const currentState = this.dataset.gridViewSwitcherState
    return this.mobileStates[
      (this.mobileStates.indexOf(currentState) + 1) % this.mobileStates.length
    ]
  }

  get desktopStates () {
    return ['2', '3', '4', '6']
  }

  get currentDesktopState () {
    return this.dataset.gridViewSwitcherStateDesktop
  }

  get nextDestkopState () {
    const currentState = this.dataset.gridViewSwitcherStateDesktop
    return this.desktopStates[
      (this.desktopStates.indexOf(currentState) + 1) % this.desktopStates.length
    ]
  }

  get imageSizes () {
    return `(max-width: 767px) ${this.mobileImageSize}, (min-width: 768px) ${this.desktopImageSize}`
  }

  get desktopImageSize () {
    return `${100 / parseInt(this.currentDesktopState)}vw`
  }

  get mobileImageSize () {
    return this.mobileImageSizes[this.currentMobileState]
  }

  get mobileImageSizes () {
    return {
      big: '100vw',
      small: '50vw',
      smallest: '33.333vw',
    }
  }

  get mobileStorageKey () {
    return 'collection_layout_key_mobile'
  }

  get desktopStorageKey () {
    return 'collection_layout_key_desktop'
  }
}

customElements.define('grid-view-switcher', GridViewSwitcher)
